import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import claimsReducer from './reducers/claimsQuestionReducer';
import stepperReducer from './reducers/stepperReducer';
import attachmentReducer from './reducers/attachmentReducer';
import modalReducer from './reducers/modalReducer';
import regionReducer from './reducers/Regions/regionReducer';
import TopBarReducer from './reducers/TopBar/TopBarReducer';

export default function configureStore() {
    const reducers = {
        stepper: stepperReducer,
        claim: claimsReducer,
        claimStore: claimsReducer,
        attachment: attachmentReducer,
        modal: modalReducer,
        region: regionReducer,
        topBar: TopBarReducer,

    };

    const middleware = [
        thunk
    ];

    // In development, use the browser's Redux dev tools extension if installed
    const enhancers = [];
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
        enhancers.push(window.devToolsExtension());
    }

    const rootReducer = combineReducers({
        ...reducers,
    });

    return createStore(
        rootReducer,
        compose(applyMiddleware(...middleware), ...enhancers)
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js